import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { IFilterDoctorDto } from 'src/app/models/ifilter-doctor-dto';
import { Item } from 'src/app/models/iscrollable-tabs';
import { ConfigService } from 'src/app/core/services/config/config.service';
import { BreadcrumbService } from 'src/app/core/services/navigation/breadcrumb.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SwiperOptions } from 'swiper';
// import { SwiperComponent } from "swiper/angular";
// import SwiperCore, { Navigation } from "swiper";
// SwiperCore.use([Navigation]);
@Component({
  selector: 'app-clinicdoctor',
  templateUrl: './clinicdoctor.component.html',
  styleUrls: ['./clinicdoctor.component.scss']
})
export class ClinicdoctorComponent implements OnInit {
  id : number ; 
  minHeight:string='300px';
  displayDoctorAppointments:boolean = false;
  minDate:Date = new Date();
  currencyName:string = "";
  isLoading:boolean;
  doctorClinics:Item[]=[]; 
  config: SwiperOptions = {
    // pagination: { 
    //   el: '.swiper-pagination', 
    //   clickable: true,

    // },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    direction: 'horizontal',
    breakpoints: {
      1024: {
        slidesPerView: 4
      },
      500: {
        slidesPerView: 4
      },
      400: {
        slidesPerView: 4
      },
      300: {
        slidesPerView: 4
      }
    },
    slidesPerView: 4,
    keyboard: true,
    mousewheel: true,
    scrollbar: false,
    //spaceBetween: 5,
    loop: false,
    autoHeight: false,
    allowTouchMove: true,
    centeredSlides:true,
    pagination: false,
  };  
  constructor(private helperService:HttphelperService,private cd:ChangeDetectorRef,private translate: TranslateService,
    private messageService: MessageService,private router:Router,public breadSer:BreadcrumbService) { 
  }

  ngOnInit(): void {
    if(this.breadSer.clinicTypeId == null || this.breadSer.clinicTypeId == undefined){
      this.router.navigate(['newrequest/category']);
      return;
    }
    let dynamicLabel = "";
    if(this.breadSer.callQueue.MobileDoctorPath == 1 || this.breadSer.callQueue.MobileDoctorPath == 3){
      dynamicLabel = "Doctors";
    }else{
      dynamicLabel = "Clinics";
      this.minHeight = '200px';
    }
    if(this.breadSer.numberOfSpecialty > 1 ){
      this.breadSer.menuItems.length = 2;
    }else{
      this.breadSer.menuItems.length = 1;
    }
    this.breadSer.menuItems.push({label: dynamicLabel, routerLink: ['clinicdoctor']});
    this.getDoctorClinics();
  }
  onSelectAppointmentDate(){
    this.getDoctorClinics();
  }
  getDoctorClinics(){
    this.doctorClinics = [];
    this.isLoading = true;
    let filter :IFilterDoctorDto  =  
    {
      SpecialtyId : this.breadSer.specialtyId,
      SortByValue : null,
      MobileDoctorPath : this.breadSer.callQueue.MobileDoctorPath,
      ClinicTypeId : this.breadSer.clinicTypeId,
      FilterName:"",
      PageNumber:1,
      PageSize:10,
      BranchId:null,
      AvailabiltyValue:null,
      Date:this.breadSer.callQueue.AppointmentDate,
      GenderValue:null
    };
    var url = `/api/Queue/GetDoctorTeleMedClinic`;
    this.helperService.postRequest(url,true,filter).subscribe(response =>
    {
      if(response.Success)
      {
        var result:any = response?.Data;
        if(result == null || result == undefined)
        {
          this.messageService.add({severity: 'warn', summary: 'Warn', detail:response.Message, life: 2000});
        }
        else
        {
          for(var i=0; i<result.length; i++){
            let item:Item;
            item ={
              serviceId : result[i].ServiceId,
              providerId: result[i].ProviderId,
              clinicId : result[i].clinicId,
              clinicName : result[i].ClinicName,
              timeSlot:result[i].TimeSlot || [],
              totalRate:result[i].TotalRate,
              price:result[i].Price,
              clinicTypeId : null,
              numberofClinic : null,
              mobileDoctorPath : null,
              numberOfSpecialty : null,
              specialtyId : null,
              text : result[i].DoctorName,
              MobileIconUrl : result[i].ImageSrc,
              addtionalData : null,
              portalPaymentOption: null
            }
            if(ConfigService.APPMainsettings != undefined){
              this.currencyName = ConfigService.APPMainsettings.Currency.CurrencyNameL;
            }
            this.doctorClinics.push(item);
          }
        }
      }
      else
      {
        this.messageService.add({severity: 'warn', summary: 'Warn', detail:response.Message, life: 2000});
      }   
      this.isLoading = false;
      this.cd.detectChanges();
    },
    error=>{
        this.messageService.add({severity: 'error', summary: 'Error', detail: error, life: 2000});
        this.isLoading = false;
        this.cd.detectChanges();
      })
  }
  selectDoctorTime(itemSelected : Item,time:string)
  {
    var dynamicLabel = itemSelected.text;
    this.breadSer.callQueue.ClinicID = itemSelected.clinicId;
    this.breadSer.callQueue.ProviderID = itemSelected.providerId;
    this.breadSer.callQueue.ServiceId = itemSelected.serviceId;
    this.breadSer.totalRate = itemSelected.totalRate;
    this.breadSer.timeSlot = itemSelected.timeSlot;
    this.breadSer.callQueue.AppointmentTime = time;
    this.breadSer.imageUrl = itemSelected.MobileIconUrl;
    this.breadSer.clinicName = itemSelected.clinicName;
    this.breadSer.doctorName = itemSelected.text;
    this.breadSer.currencyName = this.currencyName;
    this.breadSer.price = itemSelected.price;
    this.breadSer.menuItems.length = this.breadSer.menuItems.length - 1;
    if(itemSelected.text == ""){
      dynamicLabel = itemSelected.clinicName;
    }
    this.breadSer.menuItems.push(
      {label: dynamicLabel, routerLink: ['clinicdoctor']},
      {label: "Request details", routerLink: ['requestdetails']});
    this.router.navigate(['newrequest/requestdetails']);
  }
  showDoctorAppointments(itemSelected : Item){
    this.breadSer.callQueue.ProviderID = itemSelected.providerId;
    this.breadSer.totalRate = itemSelected.totalRate;
    this.breadSer.imageUrl = itemSelected.MobileIconUrl;
    this.breadSer.clinicName = itemSelected.clinicName;
    this.breadSer.doctorName = itemSelected.text;
    this.displayDoctorAppointments = true;
  }
}
